var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,15 C8.30588222,15 9.41688515,15.8343774 9.82897577,16.9990993 L21,17 C21.5522847,17 22,17.4477153 22,18 C22,18.5522847 21.5522847,19 21,19 L9.82897577,19.0009007 C9.41688515,20.1656226 8.30588222,21 7,21 C5.69411778,21 4.58311485,20.1656226 4.17102423,19.0009007 L3,19 C2.44771525,19 2,18.5522847 2,18 C2,17.4477153 2.44771525,17 3,17 L4.17102423,16.9990993 C4.58311485,15.8343774 5.69411778,15 7,15 Z M7,17 C6.44771525,17 6,17.4477153 6,18 C6,18.5522847 6.44771525,19 7,19 C7.55228475,19 8,18.5522847 8,18 C8,17.4477153 7.55228475,17 7,17 Z M17,9 C18.3058822,9 19.4168852,9.83437743 19.8289758,10.9990993 L21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 21,13 L19.8286255,13.0018902 C19.4162559,14.1660951 18.3055124,15 17,15 C15.6944876,15 14.5837441,14.1660951 14.1713745,13.0018902 L3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 L14.1710242,10.9990993 C14.5831148,9.83437743 15.6941178,9 17,9 Z M17,11 C16.4477153,11 16,11.4477153 16,12 C16,12.5522847 16.4477153,13 17,13 C17.5522847,13 18,12.5522847 18,12 C18,11.4477153 17.5522847,11 17,11 Z M12,3 C13.3058822,3 14.4168852,3.83437743 14.8289758,4.99909928 L21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.55228475 21.5522847,7 21,7 L14.8286255,7.00189021 C14.4162559,8.1660951 13.3055124,9 12,9 C10.6944876,9 9.58374415,8.1660951 9.17137452,7.00189021 L3,7 C2.44771525,7 2,6.55228475 2,6 C2,5.44771525 2.44771525,5 3,5 L9.17102423,4.99909928 C9.58311485,3.83437743 10.6941178,3 12,3 Z M12,5 C11.4477153,5 11,5.44771525 11,6 C11,6.55228475 11.4477153,7 12,7 C12.5522847,7 13,6.55228475 13,6 C13,5.44771525 12.5522847,5 12,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "settings",
    fill: "#40B3DB",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.51644929.svg";
export { ForwardRef as ReactComponent };